import React, { useState, useEffect } from 'react';
import api from '../services/api';
import TrainingDetailsModal from './TrainingDetailsModal';
import InfraDetailsModal from './InfraDetailsModal';
import * as XLSX from 'xlsx'; // Import SheetJS library for Excel export
import AdminDetailsModal from './AdminDetailsModal';
const ListView = ({
  trainings,
  handleTrainingClick,
  initialViewType,
  initialGroupBy,
  initialFilterStatus,
  refreshDataAndMaintainView,
  selectedScheme,
  selectedInstitute,
  notificationToOpen,
  onNotificationProcessed,
  selectedFinancialYear
}) => {
  // State for view type selection (training/infra)
const [viewType, setViewType] = useState(initialViewType || 'training');
  const [searchTerm, setSearchTerm] = useState('');
  const [trainingData, setTrainingData] = useState(trainings || []);
  const [infraData, setInfraData] = useState([]);
  // Add this line after the infraData state:
const [adminData, setAdminData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [expandedItems, setExpandedItems] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [groupBy, setGroupBy] = useState('none'); // moved from Dashboard
  const [exporting, setExporting] = useState(false); // New state for export loading indicator
  const [isAdminModalOpen, setIsAdminModalOpen] = useState(false);
  // Modalconst ListView = ({ trainings, handleTrainingClick, initialViewType }) => { states
  const [isTrainingModalOpen, setIsTrainingModalOpen] = useState(false);
  const [isInfraModalOpen, setIsInfraModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [filterStatus, setFilterStatus] = useState(initialFilterStatus || null);
  const [approvalQueueNotice, setApprovalQueueNotice] = useState('');
  // Add these states after your existing useState declarations
const [showLedgerPopup, setShowLedgerPopup] = useState(false);
const [ledgerData, setLedgerData] = useState({
  transactions: [],
  summary: {
    pfms: 0,
    administrative: 0,
    currentBalance: 0
  }
});
const [ledgerLoading, setLedgerLoading] = useState(false);
const [selectedLedgerInfo, setSelectedLedgerInfo] = useState({
  scheme: '',
  center: '',
  amount: ''
});
const normalizeFinancialYear = (value) => {
  const rawValue = String(value || '').trim();
  const digits = rawValue.replace(/\D/g, '');

  if (digits.length === 4) {
    return `${digits.slice(0, 2)}-${digits.slice(2, 4)}`;
  }

  return rawValue;
};

// Approval/list order: latest/current record first.
const getItemSortValue = (item) => {
  if (!item) return 0;

  // Prefer real timestamp/date fields when the API provides them.
  const dateCandidates = [
    item.updated_at,
    item.updatedAt,
    item.created_at,
    item.createdAt,
    item.created_date,
    item.createdDate,
    item.entry_date,
    item.entryDate,
    item.date
  ];

  for (const value of dateCandidates) {
    if (!value) continue;
    const parsed = new Date(value).getTime();
    if (!Number.isNaN(parsed)) return parsed;
  }

  // Training records can contain batch dates.
  if (Array.isArray(item.batchesData) && item.batchesData.length > 0) {
    const batchTimes = item.batchesData
      .flatMap(batch => [batch?.toDate, batch?.fromDate])
      .filter(Boolean)
      .map(value => new Date(value).getTime())
      .filter(value => !Number.isNaN(value));

    if (batchTimes.length > 0) {
      return Math.max(...batchTimes);
    }
  }

  // CRD records commonly carry financial year + month.
  // Example: 26-27 + 07 => July 2026.
  const normalizedYear = normalizeFinancialYear(item.year);
  const yearDigits = String(normalizedYear || '').replace(/\D/g, '');
  const month = parseInt(item.month, 10);

  if (yearDigits.length >= 4 && month >= 1 && month <= 12) {
    const startYear = 2000 + parseInt(yearDigits.slice(0, 2), 10);
    const calendarYear = month >= 4 ? startYear : startYear + 1;
    return new Date(calendarYear, month - 1, 1).getTime();
  }

  // Final fallback: newest numeric id / serial first.
  const numericFallback = Number(item.id ?? item.sno ?? 0);
  return Number.isNaN(numericFallback) ? 0 : numericFallback;
};

const sortNewestFirst = (items = []) => {
  return [...items].sort((a, b) => {
    const dateDifference = getItemSortValue(b) - getItemSortValue(a);
    if (dateDifference !== 0) return dateDifference;

    const bId = Number(b?.id ?? b?.sno ?? 0);
    const aId = Number(a?.id ?? a?.sno ?? 0);
    return (Number.isNaN(bId) ? 0 : bId) - (Number.isNaN(aId) ? 0 : aId);
  });
};
useEffect(() => {
  if (notificationToOpen) {
    console.log('🔥🔥🔥 NOTIFICATION DEBUG START 🔥🔥🔥');
    console.log('Raw notification object:', notificationToOpen);
    console.log('Notification type:', notificationToOpen.type);
    console.log('Notification id:', notificationToOpen.id);
    console.log('Notification proj_id:', notificationToOpen.proj_id);
    console.log('All notification properties:', Object.keys(notificationToOpen));
    console.log('Full notification JSON:', JSON.stringify(notificationToOpen, null, 2));
    console.log('🔥🔥🔥 NOTIFICATION DEBUG END 🔥🔥🔥');
    
    // Also log current data states
    console.log('🔥 Current trainingData count:', trainingData.length);
    console.log('🔥 Current infraData count:', infraData.length);
    console.log('🔥 Current adminData count:', adminData.length);
  }
}, [notificationToOpen, trainingData, infraData, adminData]);
console.log('=== DEBUG INFO ===');
console.log('selectedScheme:', selectedScheme);
console.log('selectedInstitute:', selectedInstitute);
console.log('trainings sample:', trainings?.[0]);
console.log('trainingData sample:', trainingData?.[0]);
console.log('filteredData count:', filteredData.length);
const [fromDate, setFromDate] = useState('');
const [monthFilter, setMonthFilter] = useState('all');
const [toDate, setToDate] = useState('');
  // Fetch infrastructure data when viewType changes to 'infra'
  // Add this helper function after your state declarations
const filterDataByScheme = (data, selectedScheme) => {
  if (!data || data.length === 0) return [];
  if (selectedScheme === 'ALL') return data;
  return data.filter(item => item.scheme === selectedScheme);
};
useEffect(() => {
  if (viewType === 'infra') {
    fetchInfraData();
  } else if (viewType === 'admin') {
    fetchAdminData();
  } else if (viewType === 'all') {
    // Fetch all data types when 'all' is selected
    fetchInfraData();
    fetchAdminData();
    // Tag training data when setting it
    const taggedTrainingData = (trainings || []).map(training => ({
      ...training,
      _itemType: 'training'
    }));
    setTrainingData(taggedTrainingData);
  } else {
    // Tag training data when setting it
    const taggedTrainingData = (trainings || []).map(training => ({
      ...training,
      _itemType: 'training'
    }));
    setTrainingData(taggedTrainingData);
  }
}, [viewType, trainings]);
// Replace the entire useEffect that handles notificationToOpen with this:

useEffect(() => {
  console.log('🔥 ListView notification received:', notificationToOpen);
  
  if (notificationToOpen && onNotificationProcessed) {
    const { id, type } = notificationToOpen;
    
    console.log('🔥 Processing notification - ID:', id, 'Type:', type);
    
    // IMPORTANT: Always fetch fresh data instead of relying on existing data
    console.log('🔥 Fetching fresh data for notification');
    fetchSpecificItemData(notificationToOpen);
  }
}, [notificationToOpen]);

// ALSO make sure you have this useEffect to handle when the modal should open
useEffect(() => {
  if (notificationToOpen && onNotificationProcessed) {
    const { id, type } = notificationToOpen;
    
    console.log('🔥 Checking existing data for notification - ID:', id, 'Type:', type);
    
    // Find the item in the correct data array
    let foundItem = null;
    
    if (type === 'training') {
      foundItem = trainingData.find(item => item.id == id || item.id == notificationToOpen.proj_id);
      console.log('🔥 Training search result:', foundItem);
    } else if (type === 'infra') {
      foundItem = infraData.find(item => item.id == id || item.id == notificationToOpen.proj_id);
      console.log('🔥 Infrastructure search result:', foundItem);
    } else if (type === 'admin') {
      foundItem = adminData.find(item => item.id == id || item.id == notificationToOpen.proj_id);
      console.log('🔥 Admin search result:', foundItem);
    }
    
    if (foundItem) {
      console.log('🔥 Found item in existing data, opening modal');
      setSelectedItem(foundItem);
      setViewType(type);
      
      // Open the appropriate modal
      setTimeout(() => {
        if (type === 'training') {
          console.log('🔥 Opening training modal');
          setIsTrainingModalOpen(true);
        } else if (type === 'infra') {
          console.log('🔥 Opening infrastructure modal');
          setIsInfraModalOpen(true);
        } else if (type === 'admin') {
          console.log('🔥 Opening admin modal');
          setIsAdminModalOpen(true);
        }
      }, 100);
      
      // Clear the notification
      onNotificationProcessed();
    } else {
      console.log('🔥 Item not found in existing data');
    }
  }
}, [notificationToOpen, trainingData, infraData, adminData]);
// Enhanced fetchSpecificItemData function
const fetchSpecificItemData = async (notification) => {
  try {
    console.log('🔥 Fetching specific item data for notification:', notification);
    
    if (notification.type === 'training') {
      console.log('🔥 Processing TRAINING notification');
      
      const response = await api.training.getTrainingList();
      
      if (response && !response.error && response.data) {
        const foundItem = response.data.find(item => {
          const matches = item.id === notification.id || 
                         item.id === parseInt(notification.id) ||
                         item.id === notification.proj_id ||
                         item.id === parseInt(notification.proj_id);
          
          if (matches) {
            console.log('🔥 Found training in API response:', item);
          }
          return matches;
        });
        
        if (foundItem) {
          console.log('🔥 Successfully fetched training data, opening modal');
          
          const taggedItem = { ...foundItem, _itemType: 'training' };
          setSelectedItem(taggedItem);
          setViewType('training'); // IMPORTANT: Set view type
          
          setTrainingData(prev => {
            const exists = prev.find(item => item.id === foundItem.id);
            if (!exists) {
              return [...prev, { ...foundItem, _itemType: 'training' }];
            }
            return prev;
          });
          
          setTimeout(() => {
            setIsTrainingModalOpen(true);
          }, 100);
        }
      }
      
    } else if (notification.type === 'infra') {
      console.log('🔥 Processing INFRASTRUCTURE notification');
      
      const endpoint = `${api.BASE_URL}/project/infra/list`;
      
      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('authToken')
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        
        if (!data.error && data.data) {
          const foundItem = data.data.find(item => {
            const matches = item.id === notification.id || 
                           item.id === parseInt(notification.id) ||
                           item.id === notification.proj_id ||
                           item.id === parseInt(notification.proj_id);
            return matches;
          });
          
          if (foundItem) {
            console.log('🔥 Successfully fetched infrastructure data, opening modal');
            
            const taggedItem = { ...foundItem, _itemType: 'infra' };
            setSelectedItem(taggedItem);
            setViewType('infra'); // IMPORTANT: Set view type
            
            setInfraData(prev => {
              const exists = prev.find(item => item.id === foundItem.id);
              if (!exists) {
                return [...prev, taggedItem];
              }
              return prev;
            });
            
            setTimeout(() => {
              console.log('🔥 About to open infrastructure modal');
              setIsInfraModalOpen(true);
            }, 100);
          } else {
            console.log('🔥 Infrastructure not found in API response');
          }
        }
      }
      
    } else if (notification.type === 'admin') {
      console.log('🔥 Processing ADMIN notification');
      
      const endpoint = `${api.BASE_URL}/project/admin/list`;
      
      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('authToken')
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        
        if (!data.error && data.data) {
          const foundItem = data.data.find(item => {
            const matches = item.id === notification.id || 
                           item.id === parseInt(notification.id) ||
                           item.id === notification.proj_id ||
                           item.id === parseInt(notification.proj_id);
            return matches;
          });
          
          if (foundItem) {
            console.log('🔥 Successfully fetched admin data, opening modal');
            
            const taggedItem = { ...foundItem, _itemType: 'admin' };
            setSelectedItem(taggedItem);
            setViewType('admin'); // IMPORTANT: Set view type
            
            setAdminData(prev => {
              const exists = prev.find(item => item.id === foundItem.id);
              if (!exists) {
                return [...prev, taggedItem];
              }
              return prev;
            });
            
            setTimeout(() => {
              setIsAdminModalOpen(true);
            }, 100);
          }
        }
      }
    }
    
  } catch (error) {
    console.error('🔥 Error fetching specific item data:', error);
  } finally {
    // Clear the notification
    if (onNotificationProcessed) {
      onNotificationProcessed();
    }
  }
};
const formatAmount = (amount) => {
  if (!amount || amount === '0' || amount === 0) return '';
  const numAmount = parseInt(amount, 10);
  if (isNaN(numAmount)) return '';
  return `₹${numAmount.toLocaleString('en-IN')}`;
};

useEffect(() => {
  if (initialFilterStatus) {
    // For specific statuses that map to grouping options
    if (initialFilterStatus === 'Approved') {
      setGroupBy('approved');
    } else if (initialFilterStatus === 'Active' || initialFilterStatus === 'Awaiting Approval') {
      setGroupBy('awaiting');
    } else if (initialFilterStatus === 'Rejected') {
      setGroupBy('rejected');
    } else {
      // For other statuses, use status-based grouping
      setGroupBy('status');
    }
    
    // Update the filter status state
    setFilterStatus(initialFilterStatus);
  }
}, [initialFilterStatus]);

// Initialize groupBy from props if provided
useEffect(() => {
  if (initialGroupBy) {
    setGroupBy(initialGroupBy);
  }
}, [initialGroupBy]);
useEffect(() => {
  let currentData;
  
  // Debug logs
  console.log('Debug - selectedScheme:', selectedScheme);
  console.log('Debug - selectedInstitute:', selectedInstitute);
  console.log('Debug - trainingData sample:', trainingData[0]);
  console.log('Debug - infraData sample:', infraData[0]);
  console.log('Debug - adminData sample:', adminData[0]);
  
  if (viewType === 'all') {
    // Combine all data types first
    let allTraining = trainingData;
    let allInfra = infraData;
    let allAdmin = adminData;
    
    // Apply scheme or institute filtering
    if (selectedScheme && selectedScheme !== 'ALL') {
      allTraining = allTraining.filter(item => 
        item.scheme === selectedScheme || 
        item.scheme_name === selectedScheme ||
        (item.scheme_name && item.scheme_name.includes(selectedScheme))
      );
      allInfra = allInfra.filter(item => 
        item.scheme === selectedScheme || 
        item.scheme_name === selectedScheme ||
        (item.scheme_name && item.scheme_name.includes(selectedScheme))
      );
      allAdmin = allAdmin.filter(item => 
        item.scheme === selectedScheme || 
        item.scheme_name === selectedScheme ||
        (item.scheme_name && item.scheme_name.includes(selectedScheme))
      );
    } else if (selectedInstitute && selectedInstitute !== 'ALL') {
      allTraining = allTraining.filter(item => item.institute === selectedInstitute);
      allInfra = allInfra.filter(item => item.institute === selectedInstitute);
      allAdmin = allAdmin.filter(item => item.institute === selectedInstitute);
    }
    
    currentData = [...allTraining, ...allInfra, ...allAdmin];
  } else if (viewType === 'training') {
    currentData = trainingData;
    
    // Apply scheme or institute filtering for training
    if (selectedScheme && selectedScheme !== 'ALL') {
      currentData = currentData.filter(item => 
        item.scheme === selectedScheme || 
        item.scheme_name === selectedScheme ||
        (item.scheme_name && item.scheme_name.includes(selectedScheme))
      );
    } else if (selectedInstitute && selectedInstitute !== 'ALL') {
      currentData = currentData.filter(item => item.institute === selectedInstitute);
    }
  } else if (viewType === 'infra') {
    currentData = infraData;
    
    // Apply scheme or institute filtering for infra
    if (selectedScheme && selectedScheme !== 'ALL') {
      currentData = currentData.filter(item => 
        item.scheme === selectedScheme || 
        item.scheme_name === selectedScheme ||
        (item.scheme_name && item.scheme_name.includes(selectedScheme))
      );
    } else if (selectedInstitute && selectedInstitute !== 'ALL') {
      currentData = currentData.filter(item => item.institute === selectedInstitute);
    }
  } else { // admin
    currentData = adminData;
    
    // Apply scheme or institute filtering for admin
    if (selectedScheme && selectedScheme !== 'ALL') {
      currentData = currentData.filter(item => 
        item.scheme === selectedScheme || 
        item.scheme_name === selectedScheme ||
        (item.scheme_name && item.scheme_name.includes(selectedScheme))
      );
    } else if (selectedInstitute && selectedInstitute !== 'ALL') {
      currentData = currentData.filter(item => item.institute === selectedInstitute);
    }
  }
  
  console.log('Debug - currentData after scheme/institute filtering:', currentData.length, currentData);
  
  //let results = currentData;
  let results = Array.isArray(currentData)
  ? currentData
  : [];

if (
  selectedFinancialYear &&
  selectedFinancialYear !== 'ALL'
) {
  results = results.filter(
    (item) =>
      normalizeFinancialYear(item.year) ===
      normalizeFinancialYear(selectedFinancialYear)
  );
}
  
  // Apply search filter
  if (searchTerm.trim()) {
    const term = searchTerm.toLowerCase();
    
    results = results.filter(item => {
      // Determine item type
      const isTraining = item.training || item.batchesData || item._itemType === 'training';
      const isAdmin = item.department || (item.title && !item.training) || item._itemType === 'admin';
      const isInfra = (item.title && !item.training && !item.department) || item._itemType === 'infra';
      
      if (isTraining) {
        // Training item filter logic
        return (
          (item.training?.toLowerCase() || '').includes(term) ||
          (item.title?.toLowerCase() || '').includes(term) ||
          (item.type?.toLowerCase() || '').includes(term) ||
          (item.institute?.toLowerCase() || '').includes(term) ||
          (item.scheme?.toLowerCase() || '').includes(term) ||
          (item.scheme_name?.toLowerCase() || '').includes(term) ||
          (item.center?.toLowerCase() || '').includes(term) ||
          (item.center_name?.toLowerCase() || '').includes(term) ||
          (typeof item.clientile === 'string' ? item.clientile.toLowerCase() : '').includes(term) ||
          (item.status?.toLowerCase() || '').includes(term) ||
          generateItemCode(item).toLowerCase().includes(term)
        );
      } else if (isInfra) {
        // Infra item filter logic
        return (
          (item.title?.toLowerCase() || '').includes(term) ||
          (item.name?.toLowerCase() || '').includes(term) ||
          (item.type?.toLowerCase() || '').includes(term) ||
          (item.category?.toLowerCase() || '').includes(term) ||
          (item.location?.toLowerCase() || '').includes(term) ||
          (item.district?.toLowerCase() || '').includes(term) ||
          (item.scheme?.toLowerCase() || '').includes(term) ||
          (item.scheme_name?.toLowerCase() || '').includes(term) ||
          (item.center_name?.toLowerCase() || '').includes(term) ||
          (item.status?.toLowerCase() || '').includes(term) ||
          generateItemCode(item).toLowerCase().includes(term)
        );
      } else {
        // Admin item filter logic
        return (
          (item.title?.toLowerCase() || '').includes(term) ||
          (item.name?.toLowerCase() || '').includes(term) ||
          (item.type?.toLowerCase() || '').includes(term) ||
          (item.department?.toLowerCase() || '').includes(term) ||
          (item.role?.toLowerCase() || '').includes(term) ||
          (item.scheme?.toLowerCase() || '').includes(term) ||
          (item.scheme_name?.toLowerCase() || '').includes(term) ||
          (item.center_name?.toLowerCase() || '').includes(term) ||
          (item.status?.toLowerCase() || '').includes(term) ||
          generateItemCode(item).toLowerCase().includes(term)
        );
      }
    });
  }

  // Apply date range filter (ONLY FOR TRAINING or ALL with training items)
  if (fromDate || toDate) {
    results = results.filter(item => {
      const isTraining = item.training || item.batchesData || item._itemType === 'training';
      if (!isTraining) return true; // Keep non-training items
      
      // Check if the training has batches
      if (item.batchesData && item.batchesData.length > 0) {
        const dateRange = getDateRange(item);
        if (!dateRange) return false;
        
        const trainingStartDate = new Date(dateRange.fromDate);
        const trainingEndDate = new Date(dateRange.toDate);
        
        if (fromDate && toDate) {
          const filterStartDate = new Date(fromDate);
          const filterEndDate = new Date(toDate);
          // Training must start within the range AND end within the range
          return trainingStartDate >= filterStartDate && trainingEndDate <= filterEndDate;
        } else if (fromDate) {
          const filterStartDate = new Date(fromDate);
          // Only check if training starts on or after the from date
          return trainingStartDate >= filterStartDate;
        } else if (toDate) {
          const filterEndDate = new Date(toDate);
          // Only check if training ends on or before the to date
          return trainingEndDate <= filterEndDate;
        }
      } else {
        // If no batchesData, use year and month fields
        if (item.year && item.month) {
          // Create a date from year and month (using day 1 for start of month)
          const trainingDate = new Date(item.year, parseInt(item.month) - 1, 1);
          // For month end, use last day of the month
          const trainingEndDate = new Date(item.year, parseInt(item.month), 0);
          
          if (fromDate && toDate) {
            const filterStartDate = new Date(fromDate);
            const filterEndDate = new Date(toDate);
            // Check if the training month falls within the range
            return trainingDate >= filterStartDate && trainingEndDate <= filterEndDate;
          } else if (fromDate) {
            const filterStartDate = new Date(fromDate);
            return trainingDate >= filterStartDate;
          } else if (toDate) {
            const filterEndDate = new Date(toDate);
            return trainingEndDate <= filterEndDate;
          }
        }
        return false; // No date information available
      }
    });
  }
  
  // Apply month filter for infra and admin items
  if (monthFilter !== 'all') {
    results = results.filter(item => {
      const isInfra = item.title && !item.training && !item.department || item._itemType === 'infra';
      const isAdmin = item.department || (item.title && !item.training) || item._itemType === 'admin';
      
      // Only apply month filter to infra or admin items
      if (isInfra || isAdmin) {
        return item.month === monthFilter;
      }
      
      return true; // Keep other items
    });
  }
  
  console.log('Debug - final results after all filtering:', results.length, results);
  setFilteredData(sortNewestFirst(results));
}, [searchTerm, trainingData, infraData, adminData, viewType, fromDate, toDate, monthFilter, selectedScheme, selectedInstitute, selectedFinancialYear]);

  // Fetch infrastructure data from API
  const fetchInfraData = async () => {
    try {
      setLoading(true);
      // Using the correct API endpoint for infrastructure
      const response = await fetch(`${api.BASE_URL}/project/infra/list`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('authToken')
        }
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch infrastructure data');
      }
      
      const data = await response.json();
      
      if (data && !data.error) {
        // Process the infrastructure data to ensure all items have a status
     const processedData = (data.data || []).map(infra => ({
  ...infra,
  _itemType: 'infra', // Add this line
  status: infra.status || 'Awaiting Approval'
}));
        setInfraData(processedData);
      } else {
        setError(data.message || 'Failed to fetch infrastructure data');
      }
    } catch (err) {
      setError('Error fetching infrastructure data: ' + (err.message || 'Unknown error'));
      console.error('Error fetching infrastructure data:', err);
    } finally {
      setLoading(false);
    }
  };
// Add this function after generateBatchCode function// Add this function after generateBatchCode function
const fetchLedgerTransactions = async (scheme, center, amount) => {
  setLedgerLoading(true);
  setSelectedLedgerInfo({ scheme, center, amount });
  setShowLedgerPopup(true);
  
  try {
    // Construct department code based on scheme and center
    const deptCode = `${center}-${scheme}`;
    
    const response = await fetch(`${api.BASE_URL}/ledger/transaction/${deptCode}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('authToken')
      }
    });
    
    if (response.ok) {
      const data = await response.json();
      
      if (!data.error && data.data) {
        const transactions = data.data;
        
        // Calculate summary - FIXED
        const pfmsTotal = transactions.reduce((sum, t) => sum + (parseFloat(t.cr) || 0), 0);
        const administrativeTotal = transactions.reduce((sum, t) => sum + (parseFloat(t.dr) || 0), 0);
        // FIXED: Current balance from first transaction (most recent)
        const currentBalance = transactions.length > 0 ? parseFloat(transactions[0].balance) : 0;
        
        setLedgerData({
          transactions,
          summary: {
            pfms: pfmsTotal,
            administrative: administrativeTotal,
            currentBalance: currentBalance
          }
        });
      } else {
        setLedgerData({
          transactions: [],
          summary: { pfms: 0, administrative: 0, currentBalance: 0 }
        });
      }
    } else {
      console.error('Failed to fetch ledger data');
      setLedgerData({
        transactions: [],
        summary: { pfms: 0, administrative: 0, currentBalance: 0 }
      });
    }
  } catch (error) {
    console.error('Error fetching ledger data:', error);
    setLedgerData({
      transactions: [],
      summary: { pfms: 0, administrative: 0, currentBalance: 0 }
    });
  } finally {
    setLedgerLoading(false);
  }
};
// Function to close the popup
const closeLedgerPopup = () => {
  setShowLedgerPopup(false);
  setLedgerData({
    transactions: [],
    summary: { pfms: 0, administrative: 0, currentBalance: 0 }
  });
  setSelectedLedgerInfo({ scheme: '', center: '', amount: '' });
};
const fetchAdminData = async () => {
  try {
    setLoading(true);
    // Using the correct API endpoint for admin
    const response = await fetch(`${api.BASE_URL}/project/admin/list`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('authToken')
      }
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch admin data');
    }
    
    const data = await response.json();
    
    if (data && !data.error) {
      // Process the admin data
  const processedData = (data.data || []).map(admin => ({
  ...admin,
  _itemType: 'admin', // Add this line
  status: admin.status || 'Pending'
}));
      setAdminData(processedData);
    } else {
      setError(data.message || 'Failed to fetch admin data');
    }
  } catch (err) {
    setError('Error fetching admin data: ' + (err.message || 'Unknown error'));
    console.error('Error fetching admin data:', err);
  } finally {
    setLoading(false);
  }
};
const fetchItemDetails = async (projectId, itemType) => {
  console.log('🔥 Note: No separate API available, using existing data');
  
  // Since there's no separate API, we'll clear the notification
  if (onNotificationProcessed) {
    onNotificationProcessed();
  }
};
const getAvailableMonths = () => {
  const currentData = viewType === 'infra' ? infraData : adminData;
  const months = new Set();
  
  currentData.forEach(item => {
    if (item.month) {
      months.add(item.month);
    }
  });
  
  return Array.from(months).sort();
};

const calculateGroupTotal = (groupItems) => {
  return groupItems.reduce((total, item) => {
    const amount = parseInt(item.amount || item.cost || item.budget || 0, 10);
    return total + amount;
  }, 0);
};

const generateItemCode = (item) => {
  // Use the tagged type if available
  const itemType = item._itemType;
  
  if (itemType === 'training') {
    return `${item.institute || ''}/${item.scheme || ''}/${item.center || ''}/${item.year || ''}/${item.month || ''}/${item.stitle || ''}/${item.sno || ''}`;
  }
  
  if (itemType === 'admin') {
    return `${item.institute || ''}/ADM/${item.scheme || ''}/${item.center || ''}/${item.year || ''}/${item.month || ''}/${item.stitle || ''}/${item.sno || ''}`;
  }
  
  if (itemType === 'infra') {
    return `${item.institute || ''}/WOR/${item.scheme || ''}/${item.center || ''}/${item.year || ''}/${item.month || ''}/${item.stitle || ''}/${item.sno || ''}`;
  }
  
  // Fallback to field detection if no type tag
  if (item.training || item.batchesData) {
    return `${item.institute || ''}/${item.scheme || ''}/${item.center || ''}/${item.year || ''}/${item.month || ''}/${item.stitle || ''}/${item.sno || ''}`;
  }
  
  if (item.department) {
    return `${item.institute || ''}/ADM/${item.scheme || ''}/${item.center || ''}/${item.year || ''}/${item.month || ''}/${item.stitle || ''}/${item.sno || ''}`;
  }
  
  // Default to infra
  return `${item.institute || ''}/WOR/${item.scheme || ''}/${item.center || ''}/${item.year || ''}/${item.month || ''}/${item.stitle || ''}/${item.sno || ''}`;
};
  // Generate batch-specific code for training
  const generateBatchCode = (training, batchNo) => {
    return `${generateItemCode(training)}/${batchNo}`;
  };

  // Get the date range for a training (from first batch start to last batch end)
  const getDateRange = (training) => {
    if (!training.batchesData || training.batchesData.length === 0) {
      return null;
    }
    
    // Sort batches by fromDate
    const sortedBatches = [...training.batchesData].sort((a, b) => 
      new Date(a.fromDate) - new Date(b.fromDate)
    );
    
    const firstBatchStart = sortedBatches[0].fromDate;
    
    // Sort batches by toDate to get the latest end date
    const batchesByEndDate = [...training.batchesData].sort((a, b) => 
      new Date(b.toDate) - new Date(a.toDate)
    );
    
    const lastBatchEnd = batchesByEndDate[0].toDate;
    
    return { fromDate: firstBatchStart, toDate: lastBatchEnd };
  };

// Helper function to filter data by institute
const filterDataByInstitute = (data, selectedInstitute) => {
  if (!data || data.length === 0) return [];
  if (selectedInstitute === 'ALL') return data;
  return data.filter(item => item.institute === selectedInstitute);
};  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Toggle expanded state for an item
  const toggleExpand = (itemId) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  // Handle item click - opens appropriate modal
const handleItemClick = (item) => {
  setSelectedItem(item);
  
  // Use the tagged type
  const itemType = item._itemType;
  
  if (itemType === 'training') {
    setIsTrainingModalOpen(true);
  } else if (itemType === 'infra') {
    setIsInfraModalOpen(true);
  } else if (itemType === 'admin') {
    setIsAdminModalOpen(true);
  } else {
    // Fallback to field detection if no type tag
    const isTraining = item.training || item.batchesData;
    const isAdmin = item.department;
    
    if (isTraining) {
      setIsTrainingModalOpen(true);
    } else if (isAdmin) {
      setIsAdminModalOpen(true);
    } else {
      setIsInfraModalOpen(true);
    }
  }
};

  // Close modals
  const closeTrainingModal = () => {
    setIsTrainingModalOpen(false);
    setSelectedItem(null);
  };

  const closeInfraModal = () => {
    setIsInfraModalOpen(false);
    setSelectedItem(null);
  };
const closeAdminModal = () => {
  setIsAdminModalOpen(false);
  setSelectedItem(null);
};

// Continuous approval queue: Training -> Infrastructure -> Admin
const isAwaitingApprovalItem = (item, type) => {
  if (!item) return false;
  if (type === 'admin') return item.status === 'Active';
  return item.status === 'Active' || item.status === 'Awaiting Approval';
};

const loadApprovalQueueData = async (type) => {
  if (type === 'training') {
    const response = await api.training.getTrainingList();
    const processedData = sortNewestFirst((response?.data || []).map(item => ({
      ...item,
      _itemType: 'training'
    })));
    setTrainingData(processedData);
    return processedData;
  }

  const endpoint = type === 'infra'
    ? `${api.BASE_URL}/project/infra/list`
    : `${api.BASE_URL}/project/admin/list`;

  const response = await fetch(endpoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('authToken')
    }
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `Failed to load ${type} approval queue`);
  }

  const result = await response.json();
  const processedData = sortNewestFirst((result?.data || []).map(item => ({
    ...item,
    _itemType: type,
    status: item.status || (type === 'infra' ? 'Awaiting Approval' : 'Pending')
  })));

  if (type === 'infra') setInfraData(processedData);
  if (type === 'admin') setAdminData(processedData);
  return processedData;
};

const matchesApprovalContext = (item) => {
  if (selectedScheme && selectedScheme !== 'ALL') {
    const matchesScheme =
      item.scheme === selectedScheme ||
      item.scheme_name === selectedScheme ||
      (item.scheme_name && item.scheme_name.includes(selectedScheme));
    if (!matchesScheme) return false;
  } else if (selectedInstitute && selectedInstitute !== 'ALL') {
    if (item.institute !== selectedInstitute) return false;
  }

  if (selectedFinancialYear && selectedFinancialYear !== 'ALL') {
    if (normalizeFinancialYear(item.year) !== normalizeFinancialYear(selectedFinancialYear)) {
      return false;
    }
  }

  return true;
};

const openApprovalQueueItem = (type, item) => {
  setApprovalQueueNotice('');
  setSelectedItem(item);
  setViewType(type);
  setGroupBy('awaiting');
  setIsTrainingModalOpen(type === 'training');
  setIsInfraModalOpen(type === 'infra');
  setIsAdminModalOpen(type === 'admin');
};

const handleApprovalActionComplete = async (completedItem, actionStatus) => {
  const currentType = completedItem?._itemType || viewType;

  // Keep the exact approval screen selected in the background.
  setViewType(currentType);
  setGroupBy('awaiting');
  setFilterStatus('Awaiting Approval');

  try {
    // Refresh ONLY the current type. Do not refresh/reset the parent dashboard.
    const freshData = await loadApprovalQueueData(currentType);

    // Current/latest pending record must be first.
    const pendingItems = sortNewestFirst(
      freshData.filter(item =>
        isAwaitingApprovalItem(item, currentType) &&
        matchesApprovalContext(item) &&
        String(item.id) !== String(completedItem?.id)
      )
    );

    if (pendingItems.length > 0) {
      // IMPORTANT: modal remains open.
      // React key changes because selectedItem.id changes, so the same modal
      // immediately shows the next newest pending record.
      setSelectedItem(pendingItems[0]);
      setIsTrainingModalOpen(currentType === 'training');
      setIsInfraModalOpen(currentType === 'infra');
      setIsAdminModalOpen(currentType === 'admin');

      setApprovalQueueNotice(
        `${actionStatus || 'Action'} successful. Next pending record loaded.`
      );
      setTimeout(() => setApprovalQueueNotice(''), 2500);
      return;
    }

    // No next pending item:
    // keep the current modal open until the user closes it manually.
    setSelectedItem(prev => ({
      ...(prev || completedItem),
      status: actionStatus || prev?.status
    }));

    setIsTrainingModalOpen(currentType === 'training');
    setIsInfraModalOpen(currentType === 'infra');
    setIsAdminModalOpen(currentType === 'admin');

    setApprovalQueueNotice('All pending approvals completed for this section.');
    setTimeout(() => setApprovalQueueNotice(''), 4000);
  } catch (queueError) {
    console.error('Error loading next pending approval:', queueError);

    // Never reset the approval list/filter even when refresh fails.
    setViewType(currentType);
    setGroupBy('awaiting');
    setFilterStatus('Awaiting Approval');

    setApprovalQueueNotice(
      'Action saved. Could not load the next pending record. Close and refresh if required.'
    );
    setTimeout(() => setApprovalQueueNotice(''), 5000);
  }
};
  // Group items by selected criteria
// Group items by selected criteria
// Group items by selected criteria
// Fixed groupedItems function - replace the existing one in ListView.js// Replace the groupedItems function in ListView.js
const groupedItems = () => {
  try {
    // For 'none' grouping option
    if (groupBy === 'none') {
      if (viewType === 'all') {
        return { 'All Items': filteredData };
      } else {
        return { 
          [viewType === 'training' ? 'All Trainings' : 
           viewType === 'infra' ? 'All Infrastructure' : 
           'All Admin Tasks']: filteredData 
        };
      }
    }
    
    // For 'all' view type with grouping
    if (viewType === 'all') {
      if (groupBy === 'approved') {
        const approvedItems = filteredData.filter(item => 
          item.status === 'Approved'
        );
        return { 'Approved': approvedItems };
      }
      
      if (groupBy === 'awaiting') {
        const awaitingItems = filteredData.filter(item => {
          if (item._itemType === 'admin') {
            return item.status === 'Active';
          } else {
            // For training and infra
            return item.status === 'Active' || item.status === 'Awaiting Approval';
          }
        });
        return { 'Awaiting Approval': awaitingItems };
      }
      
      if (groupBy === 'rejected') {
        const rejectedItems = filteredData.filter(item => 
          item.status === 'Rejected'
        );
        return { 'Rejected': rejectedItems };
      }
      
      if (groupBy === 'type') {
        // Group by item type (Training, Infrastructure, Admin)
        return filteredData.reduce((groups, item) => {
          // Use the tagged type first, then fall back to field detection
          let key;
          
          if (item._itemType === 'training') {
            key = 'Training';
          } else if (item._itemType === 'infra') {
            key = 'Infrastructure';
          } else if (item._itemType === 'admin') {
            key = 'Admin';
          } else {
            // Fallback field detection - FIXED LOGIC
            const hasTrainingFields = item.training || item.batchesData;
            const hasDepartmentField = item.department;
            
            if (hasTrainingFields) {
              key = 'Training';
            } else if (hasDepartmentField) {
              key = 'Admin';
            } else {
              key = 'Infrastructure';
            }
          }
          
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(item);
          return groups;
        }, {});
      }
      
      if (groupBy === 'institute') {
        // Group all items by institute
        return filteredData.reduce((groups, item) => {
          const key = item.institute || 'Uncategorized';
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(item);
          return groups;
        }, {});
      }
      
      if (groupBy === 'district') {
        return filteredData.reduce((groups, item) => {
          const key = item.center_name || 'Uncategorized';
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(item);
          return groups;
        }, {});
      }
      
      // Default to item type grouping for "all" view if grouping option not specifically handled
      return filteredData.reduce((groups, item) => {
        // Use the tagged type first, then fall back to field detection
        let key;
        
        if (item._itemType === 'training') {
          key = 'Training';
        } else if (item._itemType === 'infra') {
          key = 'Infrastructure';
        } else if (item._itemType === 'admin') {
          key = 'Admin';
        } else {
          // Fallback field detection - FIXED LOGIC
          const hasTrainingFields = item.training || item.batchesData;
          const hasDepartmentField = item.department;
          
          if (hasTrainingFields) {
            key = 'Training';
          } else if (hasDepartmentField) {
            key = 'Admin';
          } else {
            key = 'Infrastructure';
          }
        }
        
        if (!groups[key]) {
          groups[key] = [];
        }
        groups[key].push(item);
        return groups;
      }, {});
    }
    
    // Training specific grouping
    if (viewType === 'training') {
      if (groupBy === 'approved') {
        const approvedItems = filteredData.filter(t => t.status === 'Approved');
        return { 'Approved': approvedItems.length > 0 ? approvedItems : [] };
      }
      
      if (groupBy === 'awaiting') {
        const awaitingItems = filteredData.filter(t => 
          t.status === 'Active' || 
          t.status === 'Awaiting Approval'
        );
        return { 'Awaiting Approval': awaitingItems.length > 0 ? awaitingItems : [] };
      }
      
      if (groupBy === 'rejected') {
        const rejectedItems = filteredData.filter(t => t.status === 'Rejected');
        return { 'Rejected': rejectedItems.length > 0 ? rejectedItems : [] };
      }
      
      // Other grouping options for training
      const groups = filteredData.reduce((groups, training) => {
        let key = 'Uncategorized';
        
        if (groupBy === 'type') {
          key = training.training_type || training.type || 'Uncategorized';
        } else if (groupBy === 'month') {
          // Group by months from batchesData
          if (training.batchesData && training.batchesData.length > 0) {
            const firstBatch = training.batchesData[0];
            const date = new Date(firstBatch.fromDate);
            key = date.toLocaleString('default', { month: 'long', year: 'numeric' });
          } else {
            key = 'No Date';
          }
        } else if (groupBy === 'institute') {
          key = training.institute || 'Uncategorized';
        } else if (groupBy === 'district') {
          key = training.center_name || 'Uncategorized';
        }
        
        if (!groups[key]) {
          groups[key] = [];
        }
        
        groups[key].push(training);
        return groups;
      }, {});
      
      return Object.keys(groups).length > 0 ? groups : { 'No Matching Items': [] };
      
    } else if (viewType === 'infra') {
      // Infrastructure specific grouping
      if (groupBy === 'approved') {
        const approvedItems = filteredData.filter(i => i.status === 'Approved');
        return { 'Approved': approvedItems.length > 0 ? approvedItems : [] };
      }
      
      if (groupBy === 'awaiting') {
        const awaitingItems = filteredData.filter(i => 
          i.status === 'Active' || 
          i.status === 'Awaiting Approval'
        );
        return { 'Awaiting Approval': awaitingItems.length > 0 ? awaitingItems : [] };
      }
      
      if (groupBy === 'rejected') {
        const rejectedItems = filteredData.filter(i => i.status === 'Rejected');
        return { 'Rejected': rejectedItems.length > 0 ? rejectedItems : [] };
      }
      
      if (groupBy === 'status') {
        return filteredData.reduce((groups, infra) => {
          const key = infra.status || 'Uncategorized';
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(infra);
          return groups;
        }, {});
      } else if (groupBy === 'type') {
        return filteredData.reduce((groups, infra) => {
          const key = infra.type || infra.category || 'Uncategorized';
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(infra);
          return groups;
        }, {});
      } else if (groupBy === 'location') {
        return filteredData.reduce((groups, infra) => {
          const key = infra.location || infra.district || infra.state || 'Uncategorized';
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(infra);
          return groups;
        }, {});
      } else if (groupBy === 'district') {
        return filteredData.reduce((groups, infra) => {
          const key = infra.center_name || 'Uncategorized';
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(infra);
          return groups;
        }, {});
      }
      
      return { 'All Infrastructure': filteredData };
      
    } else {
      // Admin specific grouping
      if (groupBy === 'approved') {
        const approvedItems = filteredData.filter(a => a.status === 'Approved');
        return { 'Approved': approvedItems.length > 0 ? approvedItems : [] };
      }
      
      if (groupBy === 'awaiting') {
        const awaitingItems = filteredData.filter(a => a.status === 'Active');
        return { 'Awaiting Approval': awaitingItems.length > 0 ? awaitingItems : [] };
      }
      
      if (groupBy === 'completed') {
        const completedItems = filteredData.filter(a => a.status === 'Completed');
        return { 'Completed': completedItems.length > 0 ? completedItems : [] };
      }
      
      if (groupBy === 'rejected') {
        const rejectedItems = filteredData.filter(a => a.status === 'Rejected');
        return { 'Rejected': rejectedItems.length > 0 ? rejectedItems : [] };
      }
      
      if (groupBy === 'status') {
        return filteredData.reduce((groups, admin) => {
          const key = admin.status || 'Uncategorized';
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(admin);
          return groups;
        }, {});
      } else if (groupBy === 'type') {
        return filteredData.reduce((groups, admin) => {
          const key = admin.type || 'Uncategorized';
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(admin);
          return groups;
        }, {});
      } else if (groupBy === 'department') {
        return filteredData.reduce((groups, admin) => {
          const key = admin.department || 'Uncategorized';
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(admin);
          return groups;
        }, {});
      } else if (groupBy === 'role') {
        return filteredData.reduce((groups, admin) => {
          const key = admin.role || 'Uncategorized';
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(admin);
          return groups;
        }, {});
      } else if (groupBy === 'district') {
        return filteredData.reduce((groups, admin) => {
          const key = admin.center_name || 'Uncategorized';
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(admin);
          return groups;
        }, {});
      }
      
      return { 'All Admin Tasks': filteredData };
    }
  } catch (error) {
    console.error("Error in groupedItems function:", error);
    return { 'Error in grouping': [] };
  }
};

  // NEW FUNCTION: Export data to Excel
// NEW FUNCTION: Export data to Excel
// Revised Export to Excel function with complete data
// Enhanced Export to Excel function with formatting and proper month names
// Enhanced Export to Excel function with proper color formatting
const exportToExcel = () => {
  try {
    setExporting(true);
    
    // Get the grouped data based on current filters
    const groups = groupedItems();
    const worksheets = {};
    const workbook = XLSX.utils.book_new();
    let hasData = false;
    
    // Color palette - matching your UI colors
    const colors = {
      headerBg: "4472C4",          // Blue header background
      headerText: "FFFFFF",        // White header text
      rowEven: "E9EFF7",           // Light blue for even rows
      rowOdd: "FFFFFF",            // White for odd rows
      approved: "548235",          // Green for Approved/Active status
      awaitingApproval: "ED7D31",  // Orange for Awaiting Approval status
      inProgress: "5B9BD5",        // Blue for In Progress status
      completed: "7030A0",         // Purple for Completed status
      totalRowBg: "D9E1F2",        // Light blue for total row
      codeBg: "E6F0FF",            // Light blue background for code cells
      borderColor: "B4C6E7",       // Light blue for borders
      instituteSIR: "4472C4",      // Blue for SIR institute
      instituteRIR: "70AD47",      // Green for RIR institute
      instituteDRC: "7030A0"       // Purple for DRC institute
    };
    
    // Function to convert month number to name
    const getMonthName = (monthNum) => {
      const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      // Handle both formats (05 and 5)
      const num = parseInt(monthNum, 10);
      return isNaN(num) ? monthNum : (months[num - 1] || monthNum);
    };
    
    // Function to get cell style (used for header styling)
    const getHeaderStyle = () => ({
      font: { bold: true, color: { rgb: colors.headerText }, sz: 11 },
      fill: { patternType: 'solid', fgColor: { rgb: colors.headerBg } },
      alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
      border: {
        top: { style: 'thin', color: { rgb: colors.borderColor } },
        bottom: { style: 'thin', color: { rgb: colors.borderColor } },
        left: { style: 'thin', color: { rgb: colors.borderColor } },
        right: { style: 'thin', color: { rgb: colors.borderColor } }
      }
    });
    
    // Function to get alternating row style
    const getRowStyle = (rowIndex, colIndex = null) => {
      const baseStyle = {
        fill: { 
          patternType: 'solid',
          fgColor: { rgb: rowIndex % 2 === 0 ? colors.rowEven : colors.rowOdd } 
        },
        border: {
          top: { style: 'thin', color: { rgb: colors.borderColor } },
          bottom: { style: 'thin', color: { rgb: colors.borderColor } },
          left: { style: 'thin', color: { rgb: colors.borderColor } },
          right: { style: 'thin', color: { rgb: colors.borderColor } }
        }
      };
      
      // Special formatting for code column
      if (colIndex === 0) {
        return {
          ...baseStyle,
          font: { name: 'Consolas', color: { rgb: '0070C0' } },
          fill: { patternType: 'solid', fgColor: { rgb: colors.codeBg } }
        };
      }
      
      return baseStyle;
    };
    
    // Function to get status color
    const getStatusColor = (status) => {
      const statusLower = (status || '').toLowerCase();
      if (statusLower === 'approved' || statusLower === 'active') {
        return {
          font: { color: { rgb: colors.approved }, bold: true },
          fill: { patternType: 'solid', fgColor: { rgb: 'E2EFDA' } } // Light green bg
        };
      } else if (statusLower === 'in progress') {
        return {
          font: { color: { rgb: colors.inProgress }, bold: true },
          fill: { patternType: 'solid', fgColor: { rgb: 'DDEBF7' } } // Light blue bg
        };
      } else if (statusLower === 'completed') {
        return {
          font: { color: { rgb: colors.completed }, bold: true },
          fill: { patternType: 'solid', fgColor: { rgb: 'E4D9F0' } } // Light purple bg
        };
      } else {
        return {
          font: { color: { rgb: colors.awaitingApproval }, bold: true },
          fill: { patternType: 'solid', fgColor: { rgb: 'FCE4D6' } } // Light orange bg
        };
      }
    };
    
    // Get institute color
    const getInstituteStyle = (institute) => {
      switch(institute) {
        case 'SIR':
          return {
            font: { color: { rgb: 'FFFFFF' }, bold: true },
            fill: { patternType: 'solid', fgColor: { rgb: colors.instituteSIR } }
          };
        case 'RIR':
          return {
            font: { color: { rgb: 'FFFFFF' }, bold: true },
            fill: { patternType: 'solid', fgColor: { rgb: colors.instituteRIR } }
          };
        case 'DRC':
          return {
            font: { color: { rgb: 'FFFFFF' }, bold: true },
            fill: { patternType: 'solid', fgColor: { rgb: colors.instituteDRC } }
          };
        default:
          return {
            font: { color: { rgb: '000000' } },
            fill: { patternType: 'solid', fgColor: { rgb: 'F2F2F2' } }
          };
      }
    };
    
    // Create worksheets for each group
    Object.entries(groups).forEach(([groupName, items]) => {
      // Skip if no items
      if (items.length === 0) return;
      
      hasData = true;
      
      // Prepare data for excel based on view type
      let worksheetData = [];
      
      if (viewType === 'training') {
        // Training headers - expanded to include all fields
        const headers = [
          'Code', 'Title', 'Type', 'Institute', 'Scheme', 'Center',
          'Year', 'Month', 'Status', 'Batches', 'Total Participants', 
          'Days', 'Amount (₹)', 'Clientile Types'
        ];
        
        worksheetData.push(headers);
        
        // Add training data rows
        items.forEach((training) => {
          // Process clientile information
          let clientileString = '';
          if (training.clientile && Array.isArray(training.clientile)) {
            clientileString = training.clientile.map(c => 
              `${c.typeLabel || c.type}: ${c.member} (${c.nos})`
            ).join(', ');
          }
          
          // Convert month number to name
          const monthName = getMonthName(training.month);
          
      const row = [
  generateItemCode(training),
  training.title || training.training || '',
  training.training_type || training.type || '',
  training.institute || '',
  training.scheme_name || training.scheme || '',
  training.center_name || training.center || '',
  training.year || '',
  monthName,
  training.status || 'Awaiting Approval',
  training.batches || (training.batchesData ? training.batchesData.length : 0),
  parseInt(training.participants || 0, 10),
  training.days || '',
  parseInt(training.amount || 0, 10),  // ✅ CHANGED - Remove .toLocaleString('en-IN')
  clientileString
];
          worksheetData.push(row);
        });
      } else {
        // Infrastructure headers - expanded to include all fields
        const headers = [
          'Code', 'Title/Name', 'Type/Category', 'Institute', 'Scheme', 'Center',
          'Year', 'Month', 'Status', 'Units', 'Amount (₹)', 'Training Type'
        ];
        
        worksheetData.push(headers);
        
        // Add infrastructure data rows
        items.forEach((infra) => {
          // Convert month number to name
          const monthName = getMonthName(infra.month);
          
const row = [
  generateItemCode(infra),
  infra.title || infra.name || '',
  infra.type || infra.category || '',
  infra.institute || '',
  infra.scheme_name || infra.scheme || '',
  infra.center_name || infra.center || '',
  infra.year || '',
  monthName,
  infra.status || 'Awaiting Approval',
  infra.units || '',
  parseInt(infra.amount || 0, 10),  // ✅ CHANGED - Remove .toLocaleString('en-IN')
  infra.training_type || ''
];
          worksheetData.push(row);
        });
      }
      
      // Create a worksheet for this group
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      
// Apply styling to cells
for (let R = 0; R < worksheetData.length; ++R) {
  for (let C = 0; C < worksheetData[0].length; ++C) {
    const cell = XLSX.utils.encode_cell({ r: R, c: C });
    if (!worksheet[cell]) worksheet[cell] = { v: worksheetData[R][C], t: 'n' };
    
    if (R === 0) {
      // Header row
      worksheet[cell].s = getHeaderStyle();
    } else {
      // Data rows
      worksheet[cell].s = getRowStyle(R - 1, C);
      
      // Apply status styling to status column
      if (C === 8) { // Status column (0-based index)
        worksheet[cell].s = {
          ...worksheet[cell].s,
          ...getStatusColor(worksheetData[R][C])
        };
      }
      
      // Apply institute styling
      if (C === 3) { // Institute column
        worksheet[cell].s = {
          ...worksheet[cell].s,
          ...getInstituteStyle(worksheetData[R][C])
        };
      }
      
      // Format ALL numeric columns (Batches, Participants, Days, Amount) with comma
      if (C === 9 || C === 10 || C === 11 || C === 12) {
        // Make sure the cell type is number
        if (typeof worksheetData[R][C] === 'number') {
          worksheet[cell].t = 'n';
          worksheet[cell].z = '#,##0';
        }
        worksheet[cell].s = {
          ...worksheet[cell].s,
          alignment: { horizontal: 'right' },
          numFmt: '#,##0'
        };
      }
    }
  }
}
      
      // Add column width for better readability
      const wscols = [
        { wch: 40 }, // Code
        { wch: 40 }, // Title
        { wch: 15 }, // Type
        { wch: 10 }, // Institute
        { wch: 25 }, // Scheme
        { wch: 15 }, // Center
        { wch: 10 }, // Year
        { wch: 12 }, // Month
        { wch: 15 }, // Status
        { wch: 10 }, // Batches/Units
        { wch: 10 }, // Participants
        { wch: 8 },  // Days
        { wch: 15 }, // Amount
        { wch: 40 }  // Clientile Types/Training Type
      ];
      worksheet['!cols'] = wscols;
      
      // Set row heights
      const wsrows = [{ hpt: 25 }]; // Header row height
      for (let i = 1; i < worksheetData.length; i++) {
        wsrows.push({ hpt: 20 }); // Data row height
      }
      worksheet['!rows'] = wsrows;
      
      // Add the worksheet to our collection
      // Replace invalid characters for sheet names (limited to 31 chars)
      const validSheetName = groupName.replace(/[\\/*[\]]/g, '_').substring(0, 31);
      worksheets[validSheetName] = worksheet;
    });
    
    // If we have no data after filtering, create an empty sheet
    if (!hasData) {
      const emptySheet = XLSX.utils.aoa_to_sheet([['No data matched your current filters']]);
      // Style the "no data" message
      const cell = XLSX.utils.encode_cell({ r: 0, c: 0 });
      if (!emptySheet[cell]) emptySheet[cell] = {};
      emptySheet[cell].s = {
        font: { italic: true, color: { rgb: '999999' }, sz: 12 },
        alignment: { horizontal: 'center' }
      };
      
      // Set column width
      emptySheet['!cols'] = [{ wch: 50 }];
      // Set row height
      emptySheet['!rows'] = [{ hpt: 30 }];
      
      worksheets['No Data'] = emptySheet;
    }
    
    // Add each worksheet to the workbook
    Object.entries(worksheets).forEach(([sheetName, worksheet]) => {
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    });
    
    // For training data, add detailed sheets for batches and clientile
    if (viewType === 'training' && hasData) {
      // Only include batches for items that matched filters
      const allFilteredItems = Object.values(groups).flat();
      
      // BATCHES SHEET
      const batchesData = [];
      
      // Add header for batches sheet
      batchesData.push([
        'Training Code', 'Batch Code', 'Training Title', 'From Date', 'To Date', 
        'Participants', 'Institute', 'Scheme', 'Center', 'Status'
      ]);
      
      // Add batch details for filtered items only
      allFilteredItems.forEach(training => {
        if (training.batchesData && training.batchesData.length > 0) {
          training.batchesData.forEach(batch => {
            const batchRow = [
              generateItemCode(training),
              generateBatchCode(training, batch.batchNo),
              training.title || training.training || '',
              formatDate(batch.fromDate),
              formatDate(batch.toDate),
              batch.participants || 0,
              training.institute || '',
              training.scheme_name || training.scheme || '',
              training.center_name || training.center || '',
              training.status || 'Awaiting Approval'
            ];
            batchesData.push(batchRow);
          });
        }
      });
      
      // Only add batches sheet if we have batch data
      if (batchesData.length > 1) { // More than just the header
        const batchesSheet = XLSX.utils.aoa_to_sheet(batchesData);
        
        // Apply styling to batch sheet cells
        for (let R = 0; R < batchesData.length; ++R) {
          for (let C = 0; C < batchesData[0].length; ++C) {
            const cell = XLSX.utils.encode_cell({ r: R, c: C });
            if (!batchesSheet[cell]) batchesSheet[cell] = {};
            
            if (R === 0) {
              // Header row
              batchesSheet[cell].s = getHeaderStyle();
            } else {
              // Data rows
              batchesSheet[cell].s = getRowStyle(R - 1, C);
              
              // Apply code styling to code columns
              if (C === 0 || C === 1) {
                batchesSheet[cell].s = {
                  ...batchesSheet[cell].s,
                  font: { name: 'Consolas', color: { rgb: '0070C0' } },
                  fill: { patternType: 'solid', fgColor: { rgb: colors.codeBg } }
                };
              }
              
              // Apply status styling
              if (C === 9) {
                batchesSheet[cell].s = {
                  ...batchesSheet[cell].s,
                  ...getStatusColor(batchesData[R][C])
                };
              }
              
              // Apply institute styling
              if (C === 6) {
                batchesSheet[cell].s = {
                  ...batchesSheet[cell].s,
                  ...getInstituteStyle(batchesData[R][C])
                };
              }
              
              // Right-align participants
              if (C === 5) {
                batchesSheet[cell].s = {
                  ...batchesSheet[cell].s,
                  alignment: { horizontal: 'right' }
                };
              }
            }
          }
        }
        
        // Set column widths for batch sheet
        const batchCols = [
          { wch: 40 }, // Training Code
          { wch: 40 }, // Batch Code
          { wch: 35 }, // Title
          { wch: 15 }, // From Date
          { wch: 15 }, // To Date
          { wch: 15 }, // Participants
          { wch: 10 }, // Institute
          { wch: 20 }, // Scheme
          { wch: 15 }, // Center
          { wch: 15 }  // Status
        ];
        batchesSheet['!cols'] = batchCols;
        
        // Set row heights for batch sheet
        const batchRows = [{ hpt: 25 }]; // Header row height
        for (let i = 1; i < batchesData.length; i++) {
          batchRows.push({ hpt: 20 }); // Data row height
        }
        batchesSheet['!rows'] = batchRows;
        
        XLSX.utils.book_append_sheet(workbook, batchesSheet, 'Batch Details');
      }
      
      // CLIENTILE SHEET
      const clientileData = [];
      
      // Add header for clientile sheet
      clientileData.push([
        'Training Code', 'Training Title', 'Clientile Type', 'Member',
        'Number', 'Institute', 'Scheme', 'Center'
      ]);
      
      // Add clientile details for filtered items only
      allFilteredItems.forEach(training => {
        if (training.clientile && Array.isArray(training.clientile) && training.clientile.length > 0) {
          training.clientile.forEach(client => {
            const clientRow = [
              generateItemCode(training),
              training.title || training.training || '',
              client.typeLabel || client.type || '',
              client.member || '',
              client.nos || 0,
              training.institute || '',
              training.scheme_name || training.scheme || '',
              training.center_name || training.center || ''
            ];
            clientileData.push(clientRow);
          });
        }
      });
      
      // Only add clientile sheet if we have clientile data
      if (clientileData.length > 1) { // More than just the header
        const clientileSheet = XLSX.utils.aoa_to_sheet(clientileData);
        
        // Apply styling to clientile sheet cells
        for (let R = 0; R < clientileData.length; ++R) {
          for (let C = 0; C < clientileData[0].length; ++C) {
            const cell = XLSX.utils.encode_cell({ r: R, c: C });
            if (!clientileSheet[cell]) clientileSheet[cell] = {};
            
            if (R === 0) {
              // Header row
              clientileSheet[cell].s = getHeaderStyle();
            } else {
              // Data rows
              clientileSheet[cell].s = getRowStyle(R - 1, C);
              
              // Apply code styling to code column
              if (C === 0) {
                clientileSheet[cell].s = {
                  ...clientileSheet[cell].s,
                  font: { name: 'Consolas', color: { rgb: '0070C0' } },
                  fill: { patternType: 'solid', fgColor: { rgb: colors.codeBg } }
                };
              }
              
              // Apply institute styling
              if (C === 5) {
                clientileSheet[cell].s = {
                  ...clientileSheet[cell].s,
                  ...getInstituteStyle(clientileData[R][C])
                };
              }
              
              // Right-align number
              if (C === 4) {
                clientileSheet[cell].s = {
                  ...clientileSheet[cell].s,
                  alignment: { horizontal: 'right' }
                };
              }
            }
          }
        }
        
        // Set column widths for clientile sheet
        const clientCols = [
          { wch: 40 }, // Training Code
          { wch: 35 }, // Title
          { wch: 20 }, // Type
          { wch: 25 }, // Member
          { wch: 10 }, // Number
          { wch: 10 }, // Institute
          { wch: 20 }, // Scheme
          { wch: 15 }  // Center
        ];
        clientileSheet['!cols'] = clientCols;
        
        // Set row heights for clientile sheet
        const clientRows = [{ hpt: 25 }]; // Header row height
        for (let i = 1; i < clientileData.length; i++) {
          clientRows.push({ hpt: 20 }); // Data row height
        }
        clientileSheet['!rows'] = clientRows;
        
        XLSX.utils.book_append_sheet(workbook, clientileSheet, 'Clientile Details');
      }
    }
    
    // SUMMARY SHEET
    const summaryData = [
      ['Group', 'Count']
    ];
    
    // Add summary data with total
    let totalCount = 0;
    Object.entries(groups).forEach(([groupName, items]) => {
      summaryData.push([groupName, items.length]);
      totalCount += items.length;
    });
    
    // Add total row
    summaryData.push(['Total', totalCount]);
    
    const summarySheet = XLSX.utils.aoa_to_sheet(summaryData);
    
    // Apply styling to summary sheet cells
    for (let R = 0; R < summaryData.length; ++R) {
      for (let C = 0; C < summaryData[0].length; ++C) {
        const cell = XLSX.utils.encode_cell({ r: R, c: C });
        if (!summarySheet[cell]) summarySheet[cell] = {};
        
        if (R === 0) {
          // Header row
          summarySheet[cell].s = getHeaderStyle();
        } else if (R === summaryData.length - 1) {
          // Total row
          summarySheet[cell].s = {
            font: { bold: true, sz: 11 },
            fill: { patternType: 'solid', fgColor: { rgb: colors.totalRowBg } },
            border: {
              top: { style: 'thin', color: { rgb: colors.borderColor } },
              bottom: { style: 'thin', color: { rgb: colors.borderColor } },
              left: { style: 'thin', color: { rgb: colors.borderColor } },
              right: { style: 'thin', color: { rgb: colors.borderColor } }
            },
            alignment: C === 1 ? { horizontal: 'right' } : {}
          };
        } else {
          // Data rows
          summarySheet[cell].s = {
            ...getRowStyle(R - 1),
            alignment: C === 1 ? { horizontal: 'right' } : {}
          };
        }
      }
    }
    
    // Set column widths for summary sheet
    summarySheet['!cols'] = [
      { wch: 30 }, // Group name
      { wch: 15 }  // Count
    ];
    
    // Set row heights for summary sheet
    const summaryRows = [{ hpt: 25 }]; // Header row height
    for (let i = 1; i < summaryData.length; i++) {
      summaryRows.push({ hpt: 20 }); // Data row height
    }
    summarySheet['!rows'] = summaryRows;
    
    XLSX.utils.book_append_sheet(workbook, summarySheet, 'Summary');
    
    // Generate Excel file name based on current date, view type and filters
    const dateStr = new Date().toISOString().split('T')[0];
    let fileNamePrefix = viewType === 'training' ? 'Trainings' : 
                        viewType === 'infra' ? 'Infrastructure' : 
                        'AdminTasks';
    if (searchTerm) {
      fileNamePrefix += `_Search_${searchTerm.replace(/[^a-z0-9]/gi, '_')}`;
    }
    if (groupBy !== 'none') {
      fileNamePrefix += `_By_${groupBy.charAt(0).toUpperCase() + groupBy.slice(1)}`;
    }
    if (fromDate) {
      fileNamePrefix += `_From_${fromDate}`;
    }
    if (toDate) {
      fileNamePrefix += `_To_${toDate}`;
    }
    const fileName = `${fileNamePrefix}_${dateStr}.xlsx`;
    
    // Write the workbook and trigger download
    XLSX.writeFile(workbook, fileName);
  } catch (error) {
    console.error('Error exporting to Excel:', error);
    alert('Failed to export data. Please try again.');
  } finally {
    setExporting(false);
  }
};
  // Render different item views based on view type
const renderItem = (item) => {
  // Use the tagged type if available
  const itemType = item._itemType;
  
  if (itemType === 'training') {
    return renderTrainingItem(item);
  } else if (itemType === 'infra') {
    return renderInfraItem(item);
  } else if (itemType === 'admin') {
    return renderAdminItem(item);
  }
  
  // Fallback to field detection if no type tag
  const isTraining = item.training || item.batchesData || item.isIEC || item.isHandholding || item.isModule || item.isPLC;
  const isAdmin = item.department && !isTraining;
  const isInfra = !isTraining && !isAdmin;
  
  if (isTraining) {
    return renderTrainingItem(item);
  } else if (isAdmin) {
    return renderAdminItem(item);
  } else {
    return renderInfraItem(item);
  }
};

const renderTrainingItem = (training) => {
  const dateRange = getDateRange(training);
  
  // DEBUG - TEMPORARY
  console.log('🔍 Rendering training:', {
    id: training.id,
    title: training.title,
    institute: training.institute,
    isIEC: training.isIEC,
    isHandholding: training.isHandholding,
    isModule: training.isModule,
    isPLC: training.isPLC,
    type: training.type,
    hasInstitute: !!training.institute
  });
  
  return (
    <div key={training.id} className="p-3 hover:bg-gray-50 transition duration-150">
      {/* Responsive layout for training item */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
        {/* Main training code button */}
        <button 
          onClick={() => handleItemClick(training)}
          className="text-sm font-mono text-blue-600 hover:text-blue-800 hover:underline bg-blue-50 px-2 py-1 rounded break-all shadow-sm hover:shadow transition-all duration-150"
        >
          {generateItemCode(training)}
        </button>
        
        {/* Basic info and expand button - now in flex-wrap */}
        <div className="flex flex-wrap items-center gap-2">
<span className="text-xs px-2 py-0.5 rounded bg-gray-100 shadow-sm">
  {training.title?.substring(0, 20) || training.training?.substring(0, 20)}
  {(training.title?.length > 20 || training.training?.length > 20) ? '...' : ''}
</span>

{/* Type tag - only show for regular trainings (not special types) */}
{!training.isIEC && !training.isHandholding && !training.isModule && !training.isPLC && training.type && (
  <span className="text-xs px-2 py-0.5 rounded bg-gray-100 shadow-sm">
    {training.type}
  </span>
)}

{/* Institute tag - ALWAYS show */}
<span className={`text-xs px-2 py-0.5 rounded shadow-sm ${
  training.institute === 'SIR' ? 'bg-blue-100 text-blue-800' :
  training.institute === 'RIR' ? 'bg-green-100 text-green-800' :
  training.institute === 'DRC' ? 'bg-purple-100 text-purple-800' :
  'bg-gray-100 text-gray-800'
}`}>
  {training.institute}
</span>

{/* Date range tag - only for trainings with batchesData */}
{dateRange && (
  <span className="text-xs px-2 py-0.5 rounded bg-blue-100 text-blue-800 shadow-sm">
    {formatDate(dateRange.fromDate)} - {formatDate(dateRange.toDate)}
  </span>
)}

{/* Batches count tag - only for trainings with batches */}
{(training.batches || training.batchesData) && (
  <span className="text-xs px-2 py-0.5 rounded bg-yellow-100 text-yellow-800 shadow-sm">
    {training.batches || (training.batchesData ? training.batchesData.length : 0)} batch{(training.batches > 1 || (training.batchesData && training.batchesData.length > 1)) ? 'es' : ''}
  </span>
)}

{/* Participants count tag - only for trainings with participants */}
{training.participants && (
  <span className="text-xs px-2 py-0.5 rounded bg-indigo-100 text-indigo-800 shadow-sm">
    {training.participants} participant{training.participants !== '1' ? 's' : ''}
  </span>
)}
          
{/* Clickable Amount tag - show appropriate amount based on training type */}
{(() => {
  let amountToShow = null;
  let amountValue = null;
  let shouldShowZero = false; // Flag to show zero for special trainings
  
  if (training.isHandholding) {
    amountValue = training.handholdingAmount;
    shouldShowZero = true;
    amountToShow = amountValue ? formatAmount(amountValue) : '₹0';
  } else if (training.isIEC) {
    amountValue = training.iecAmount;
    shouldShowZero = true;
    amountToShow = amountValue ? formatAmount(amountValue) : '₹0';
  } else if (training.isModule) {
    amountValue = training.moduleAmount;
    shouldShowZero = true;
    amountToShow = amountValue ? formatAmount(amountValue) : '₹0';
  } else if (training.isPLC) {
    amountValue = training.plcAmount;
    shouldShowZero = true;
    amountToShow = amountValue ? formatAmount(amountValue) : '₹0';
  } else if (training.amount) {
    amountValue = training.amount;
    amountToShow = formatAmount(training.amount);
  }
  
  // Show amount if it exists OR if it's a special training type (even with zero)
  return (amountToShow || shouldShowZero) ? (
    <button
      onClick={(e) => {
        e.stopPropagation();
        fetchLedgerTransactions(
          training.scheme, 
          training.center || training.center_name, 
          amountToShow || '₹0'
        );
      }}
      className="text-xs px-2 py-0.5 rounded bg-emerald-100 text-emerald-800 shadow-sm font-medium hover:bg-emerald-200 hover:shadow-md transition-all duration-150 cursor-pointer"
      title="View ledger transactions for this amount"
    >
      {amountToShow || '₹0'}
    </button>
  ) : null;
})()}
          {/* Status tag with color */}
          <span className={`text-xs px-2 py-0.5 rounded shadow-sm ${
            training.status === 'Approved' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
          }`}>
            {training.status || 'Awaiting Approval'}
          </span>
          
          {training.batchesData && training.batchesData.length > 0 && (
            <button 
              onClick={() => toggleExpand(training.id)}
              className="text-xs text-gray-500 hover:text-gray-700 focus:outline-none ml-1 bg-gray-50 p-1 rounded-full hover:bg-gray-100 transition-colors duration-150"
            >
              {expandedItems[training.id] ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              )}
            </button>
          )}
        </div>
      </div>
      
      {/* Responsive expanded batch details */}
      {expandedItems[training.id] && training.batchesData && (
        <div className="mt-3 pl-3 border-l-2 border-gray-200 overflow-x-auto animate-fadeIn">
          <div className="min-w-full">
            <table className="min-w-full border rounded-lg overflow-hidden shadow-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Batch Code</th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Period</th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Participants</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {training.batchesData.map(batch => (
                  <tr key={batch.batchNo} className="hover:bg-gray-50 transition-colors duration-150">
                    <td className="px-3 py-2 whitespace-nowrap text-xs font-mono text-blue-600 break-all md:break-normal">
                      {generateBatchCode(training, batch.batchNo)}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-700">
                      {formatDate(batch.fromDate)} to {formatDate(batch.toDate)}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-700">
                      {batch.participants}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

  // Render an infrastructure item
const renderInfraItem = (infra) => {
  return (
    <div key={infra.id} className="p-3 hover:bg-gray-50 transition duration-150">
      {/* Responsive layout for infra item */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
        {/* Main infra code button */}
        <button 
          onClick={() => handleItemClick(infra)}
          className="text-sm font-mono text-blue-600 hover:text-blue-800 hover:underline bg-blue-50 px-2 py-1 rounded break-all shadow-sm hover:shadow transition-all duration-150"
        >
          {generateItemCode(infra)}
        </button>
        
        {/* Basic info - in flex-wrap */}
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs px-2 py-0.5 rounded bg-gray-100 shadow-sm">
            {infra.title?.substring(0, 20) || infra.name?.substring(0, 20)}
            {(infra.title?.length > 20 || infra.name?.length > 20) ? '...' : ''}
          </span>
          
          {/* Type tag */}
          <span className="text-xs px-2 py-0.5 rounded bg-gray-100 shadow-sm">
            {infra.type || infra.category || 'Unknown Type'}
          </span>
  {/* Clickable Amount tag for Infrastructure */}
{formatAmount(infra.cost || infra.amount) && (
  <button
    onClick={(e) => {
      e.stopPropagation();
      fetchLedgerTransactions(
        infra.scheme, 
        infra.center || infra.center_name, 
        formatAmount(infra.cost || infra.amount)
      );
    }}
    className="text-xs px-2 py-0.5 rounded bg-emerald-100 text-emerald-800 shadow-sm font-medium hover:bg-emerald-200 hover:shadow-md transition-all duration-150 cursor-pointer"
    title="View ledger transactions for this amount"
  >
    {formatAmount(infra.cost || infra.amount)}
  </button>
)}
          
          {/* Timeline tag */}
          {(infra.timeline || infra.duration) && (
            <span className="text-xs px-2 py-0.5 rounded bg-indigo-100 text-indigo-800 shadow-sm">
              {infra.timeline || `${infra.duration} ${infra.duration === 1 ? 'month' : 'months'}`}
            </span>
          )}
          
          {/* Status tag with color */}
          <span className={`text-xs px-2 py-0.5 rounded shadow-sm ${
            infra.status === 'Approved' ? 'bg-green-100 text-green-800' : 
            infra.status === 'In Progress' ? 'bg-blue-100 text-blue-800' : 
            infra.status === 'Completed' ? 'bg-purple-100 text-purple-800' : 
            'bg-yellow-100 text-yellow-800'
          }`}>
            {infra.status || 'Awaiting Approval'}
          </span>
        </div>
      </div>
    </div>
  );
};

// Add this function after renderInfraItem:
const renderAdminItem = (admin) => {
  return (
    <div key={admin.id} className="p-3 hover:bg-gray-50 transition duration-150">
      {/* Responsive layout for admin item */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
        {/* Main admin code button */}
        <button 
          onClick={() => handleItemClick(admin)}
          className="text-sm font-mono text-blue-600 hover:text-blue-800 hover:underline bg-blue-50 px-2 py-1 rounded break-all shadow-sm hover:shadow transition-all duration-150"
        >
          {generateItemCode(admin)}
        </button>
        
        {/* Basic info - in flex-wrap */}
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs px-2 py-0.5 rounded bg-gray-100 shadow-sm">
            {admin.title?.substring(0, 20) || admin.name?.substring(0, 20)}
            {(admin.title?.length > 20 || admin.name?.length > 20) ? '...' : ''}
          </span>
          
          {/* Type tag */}
          <span className="text-xs px-2 py-0.5 rounded bg-gray-100 shadow-sm">
            {admin.type || 'General'}
          </span>
          
          {/* Users Managed tag */}
          {admin.usersManaged && (
            <span className="text-xs px-2 py-0.5 rounded bg-blue-100 text-blue-800 shadow-sm">
              {admin.usersManaged} user{admin.usersManaged !== 1 ? 's' : ''}
            </span>
          )}
          
    {/* Clickable Amount tag for Admin */}
{formatAmount(admin.amount || admin.cost || admin.budget) && (
  <button
    onClick={(e) => {
      e.stopPropagation();
      fetchLedgerTransactions(
        admin.scheme, 
        admin.center || admin.center_name, 
        formatAmount(admin.amount || admin.cost || admin.budget)
      );
    }}
    className="text-xs px-2 py-0.5 rounded bg-emerald-100 text-emerald-800 shadow-sm font-medium hover:bg-emerald-200 hover:shadow-md transition-all duration-150 cursor-pointer"
    title="View ledger transactions for this amount"
  >
    {formatAmount(admin.amount || admin.cost || admin.budget)}
  </button>
)}
          
          {/* Status tag with color */}
          <span className={`text-xs px-2 py-0.5 rounded shadow-sm ${
            admin.status === 'Active' ? 'bg-green-100 text-green-800' : 
            admin.status === 'Completed' ? 'bg-purple-100 text-purple-800' : 
            'bg-yellow-100 text-yellow-800'
          }`}>
            {admin.status || 'Pending'}
          </span>
        </div>
      </div>
    </div>
  );
};
const DebugInfo = () => (
  <div className="mb-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
    <h4 className="font-semibold text-yellow-800 mb-2">Debug Information:</h4>
    <div className="text-sm text-yellow-700 space-y-1">
      <div><strong>Selected Scheme:</strong> {selectedScheme || 'None'}</div>
      <div><strong>Selected Institute:</strong> {selectedInstitute || 'None'}</div>
      <div><strong>View Type:</strong> {viewType}</div>
      <div><strong>Training Data Count:</strong> {trainingData.length}</div>
      <div><strong>Filtered Data Count:</strong> {filteredData.length}</div>
      <div><strong>Sample Training Data:</strong></div>
      <pre className="text-xs bg-white p-2 rounded border overflow-auto max-h-32">
        {JSON.stringify(trainingData[0], null, 2)}
      </pre>
    </div>
  </div>
);
  return (
    <div className="space-y-4">
      {/* View type selector, grouping, search input, and export button in a premium horizontal control band */}
      <div className="rounded-lg bg-gradient-to-r from-blue-50 to-indigo-50 p-4 shadow-sm border border-blue-100">
        <div className="flex flex-wrap md:flex-nowrap items-center gap-4">
          {/* View type selector with enhanced styling */}
          <div className="w-full md:w-1/5">
            <div className="relative">
              <label className="block text-xs font-medium text-gray-500 mb-1 ml-1">View Type</label>

<select
  value={viewType}
  onChange={(e) => setViewType(e.target.value)}
  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm py-2 bg-white"
  aria-label="Select view type"
>
  <option value="all">All</option>
  <option value="training">Training</option>
  <option value="infra">Infrastructure</option>
  <option value="admin">Admin</option>
</select>
            </div>
          </div>



<div className="w-full md:w-1/5">
  <div className="relative">
    <label className="block text-xs font-medium text-gray-500 mb-1 ml-1">Group By</label>
    <select 
      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm py-2 bg-white"
      value={groupBy}
      onChange={(e) => setGroupBy(e.target.value)}
      aria-label="Group by"
    >
      <option value="none">No Grouping</option>
{viewType === 'all' ? (
  <>
    <option value="approved">Approved</option>
    <option value="awaiting">Awaiting Approval</option>
    <option value="institute">Institute</option>  {/* ADD THIS LINE */}
    {localStorage.getItem('userRole') === 'department' && (
      <option value="district">District</option>
    )}
  </>
     ) : viewType === 'training' ? (
  <>
    <option value="approved">Approved</option>
    <option value="awaiting">Awaiting Approval</option>
    <option value="rejected">Rejected</option>
    <option value="type">Training Type</option>
    <option value="month">Month</option>
    <option value="institute">Institute</option>
    {localStorage.getItem('userRole') === 'department' && (
      <option value="district">District</option>
    )}
  </>
     ) : viewType === 'infra' ? (
  <>
    <option value="approved">Approved</option>
    <option value="awaiting">Awaiting Approval</option>
    <option value="rejected">Rejected</option>
    <option value="institute">Institute</option>  {/* ADD THIS LINE */}
    {localStorage.getItem('userRole') === 'department' && (
      <option value="district">District</option>
    )}
  </>
    ) : (
  <>
    <option value="approved">Approved</option>
    <option value="awaiting">Awaiting Approval</option>
    <option value="rejected">Rejected</option>
    <option value="institute">Institute</option>  {/* ADD THIS LINE */}
    {localStorage.getItem('userRole') === 'department' && (
      <option value="district">District</option>
    )}
  </>
      )}
    </select>
  </div>
</div>  {/* Search input with enhanced styling */}
          <div className="w-full md:w-2/5">
            <div className="relative">
              <label className="block text-xs font-medium text-gray-500 mb-1 ml-1">Search</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <svg className="w-4 h-4 text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
                  </svg>
                </div>
                <input 
                  type="search" 
                  className="block w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-md bg-white focus:ring-blue-500 focus:border-blue-500 shadow-sm"
placeholder={
  viewType === 'all' ? "Search all items..." :
  viewType === 'training' ? "Search trainings..." : 
  viewType === 'infra' ? "Search infrastructure..." : 
  "Search admin tasks..."
}
                  value={searchTerm}
                  onChange={handleSearchChange}
                  aria-label="Search"
                />
              </div>
            </div>
          </div>
{/* Date Range Filter - Only for Training */}
{viewType === 'training' && (
  <>
    <div className="w-full md:w-1/5">
      <div className="relative">
        <label className="block text-xs font-medium text-gray-500 mb-1 ml-1">From Date</label>
        <input
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm py-2 bg-white"
          aria-label="From date"
        />
      </div>
    </div>

    <div className="w-full md:w-1/5">
      <div className="relative">
        <label className="block text-xs font-medium text-gray-500 mb-1 ml-1">To Date</label>
        <input
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm py-2 bg-white"
          aria-label="To date"
        />
      </div>
    </div>
  </>
)}

{/* Month Filter - Only for Infra and Admin */}
{(viewType === 'infra' || viewType === 'admin') && (
  <div className="w-full md:w-1/5">
    <div className="relative">
      <label className="block text-xs font-medium text-gray-500 mb-1 ml-1">Month</label>
      <select
        value={monthFilter}
        onChange={(e) => setMonthFilter(e.target.value)}
        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm py-2 bg-white"
        aria-label="Filter by month"
      >
        <option value="all">All Months</option>
        {getAvailableMonths().map(month => (
          <option key={month} value={month}>
            {new Date(2024, parseInt(month) - 1).toLocaleString('default', { month: 'long' })}
          </option>
        ))}
      </select>
    </div>
  </div>
)}
         
          {/* Export to Excel button */}
          <div className="w-full md:w-1/5">
            <div className="relative">
              <label className="block text-xs font-medium text-gray-500 mb-1 ml-1">Export</label>
              <button
                onClick={exportToExcel}
                disabled={loading || exporting || filteredData.length === 0}
                className={`flex items-center justify-center w-full px-4 py-2 text-sm font-medium rounded-md shadow-sm
                  ${loading || exporting || filteredData.length === 0 
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed' 
                    : 'bg-green-600 hover:bg-green-700 text-white hover:shadow-md transition-all duration-150'}`}
              >

{exporting ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Exporting...
                  </>
                ) : (
                  <>
                    <svg className="w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                    </svg>
                    Export to Excel
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Loading state with enhanced styling */}
      {loading && (
        <div className="text-center py-8 bg-white rounded-lg shadow-sm border border-gray-100">
          <svg className="animate-spin h-6 w-6 text-blue-500 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
<p className="mt-2 text-gray-600">Loading {
  viewType === 'training' ? 'trainings' : 
  viewType === 'infra' ? 'infrastructure data' : 
  'admin data'
}...</p>
        </div>
      )}

      {/* Error state with enhanced styling */}
      {error && (
        <div className="text-center py-6 bg-red-50 rounded-lg shadow-sm border border-red-100">
          <svg className="h-8 w-8 text-red-500 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="mt-2 text-red-600 font-medium">{error}</p>
          <button 
         onClick={viewType === 'training' ? 
  () => setTrainingData(trainings) : 
  viewType === 'infra' ? 
    fetchInfraData : 
    fetchAdminData}
            className="mt-3 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 shadow-sm transition-colors duration-150"
          >
            Try Again
          </button>
        </div>
      )}

      {/* Items list grouped by criteria with enhanced styling */}
     {!loading && !error && (
  <div className="space-y-6">
    {Object.entries(groupedItems()).map(([groupName, groupItems]) => (
      <div key={groupName} className="border rounded-lg overflow-hidden shadow-sm transition-all duration-150 hover:shadow">
        <div className={`p-3 font-medium ${
          groupName === 'Approved' ? 'bg-green-100 border-b border-green-200' : 
          groupName === 'Awaiting Approval' ? 'bg-yellow-100 border-b border-yellow-200' : 
          groupName === 'Rejected' ? 'bg-red-100 border-b border-red-200' : 
          'bg-gradient-to-r from-gray-100 to-gray-50 border-b border-gray-200'
        }`}>
          <div className="flex justify-between items-center">
            <span>{groupName}</span>
            <span className="bg-white text-sm px-2 py-0.5 rounded-full shadow-sm text-gray-600">
              {groupItems.length} {groupItems.length === 1 ? 'item' : 'items'}
            </span>
          </div>
        </div>
        <div className="divide-y bg-white">
          {groupItems.map(item => renderItem(item))}
        </div>
        
        {/* Group Total Summary */}
        {groupItems.length > 0 && (
          <div className={`p-3 border-t-2 ${
            groupName === 'Approved' ? 'bg-green-50 border-green-300' : 
            groupName === 'Awaiting Approval' ? 'bg-yellow-50 border-yellow-300' : 
            groupName === 'Rejected' ? 'bg-red-50 border-red-300' : 
            'bg-gray-50 border-gray-300'
          }`}>
            <div className="flex justify-between items-center">
              <span className="text-sm font-medium text-gray-700">
                Total {groupName} Amount:
              </span>
              <span className={`text-lg font-bold ${
                groupName === 'Approved' ? 'text-green-700' : 
                groupName === 'Awaiting Approval' ? 'text-yellow-700' : 
                groupName === 'Rejected' ? 'text-red-700' : 
                'text-gray-700'
              }`}>
                ₹{calculateGroupTotal(groupItems).toLocaleString('en-IN')}
              </span>
            </div>
           
          </div>
        )}
      </div>
    ))}
    
    {filteredData.length === 0 && (
      <div className="text-center py-10 bg-gray-50 rounded-lg border border-gray-100 shadow-sm">
        <svg className="h-12 w-12 text-gray-400 mx-auto mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <p className="text-gray-500 text-lg">
          No {
            viewType === 'all' ? 'items' :
            viewType === 'training' ? 'trainings' : 
            viewType === 'infra' ? 'infrastructure items' : 
            'admin tasks'
          } found matching your search.
        </p>
        <p className="text-gray-400 text-sm mt-1">
          Try adjusting your search or filters.
        </p>
      </div>
    )}
  </div>
)}

{approvalQueueNotice && (
  <div className="fixed top-20 right-6 z-[70] bg-gray-900 text-white px-4 py-3 rounded-lg shadow-lg text-sm">
    {approvalQueueNotice}
  </div>
)}

{/* Training Details Modal */}
{isTrainingModalOpen && selectedItem && (
  <TrainingDetailsModal 
    key={`training-${selectedItem.id}`}
    isOpen={isTrainingModalOpen}
    training={selectedItem}
    onClose={closeTrainingModal}
    fetchTrainings={() => loadApprovalQueueData('training')}
    onActionComplete={handleApprovalActionComplete}
  />
)}
{/* Admin Details Modal */}
{isAdminModalOpen && selectedItem && (
  <AdminDetailsModal 
    key={`admin-${selectedItem.id}`}
    isOpen={isAdminModalOpen}
    admin={selectedItem}
    onClose={closeAdminModal}
    fetchAdminData={() => loadApprovalQueueData('admin')}
    onActionComplete={handleApprovalActionComplete}
  />
)}
{/* Infrastructure Details Modal */}
{isInfraModalOpen && selectedItem && (
  <InfraDetailsModal 
    key={`infra-${selectedItem.id}`}
    isOpen={isInfraModalOpen}
    infra={selectedItem}
    onClose={closeInfraModal}
    fetchInfraData={() => loadApprovalQueueData('infra')}
    onActionComplete={handleApprovalActionComplete}
  />
)}
{/* Ledger Popup Modal */}
{showLedgerPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
      {/* Header */}
      <div className="p-4 border-b border-gray-200 bg-gray-50">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-medium text-gray-800">
            Ledger Transactions - {selectedLedgerInfo.scheme} ({selectedLedgerInfo.center})
          </h3>
          <button
            onClick={closeLedgerPopup}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
     
      </div>

      {/* Content */}
      <div className="p-4 overflow-y-auto max-h-[calc(90vh-120px)]">
        {ledgerLoading ? (
          <div className="flex justify-center items-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
            <span className="ml-2 text-gray-600">Loading transactions...</span>
          </div>
        ) : (
          <>
            {/* Summary Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <div className="bg-green-50 p-4 rounded-lg border border-green-100">
                <p className="text-sm text-green-800">As per PFMS</p>
                <p className="text-xl font-bold text-green-600">
                  ₹{ledgerData.summary.pfms.toLocaleString('en-IN')}
                </p>
              </div>
              <div className="bg-red-50 p-4 rounded-lg border border-red-100">
                <p className="text-sm text-red-800">As per Administrative Sanctioned</p>
                <p className="text-xl font-bold text-red-600">
                  ₹{ledgerData.summary.administrative.toLocaleString('en-IN')}
                </p>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg border border-blue-100">
                <p className="text-sm text-blue-800">Current Balance</p>
                <p className="text-xl font-bold text-blue-600">
                  ₹{ledgerData.summary.currentBalance.toLocaleString('en-IN')}
                </p>
              </div>
            </div>

            {/* Transactions Table */}
            {ledgerData.transactions.length > 0 ? (
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 border border-gray-200 rounded-lg">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Date
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Particulars
                      </th>
                      <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Amount
                      </th>
                      <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Balance
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {ledgerData.transactions.map((transaction, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600">
                          {new Date(transaction.date).toLocaleDateString('en-IN', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric'
                          })}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600">
                          {transaction.particulars}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-right">
                          {transaction.cr && transaction.cr !== "0.00" ? (
                            <span className="text-green-600 font-medium">
                              +₹{parseFloat(transaction.cr).toLocaleString('en-IN')}
                            </span>
                          ) : transaction.dr && transaction.dr !== "0.00" ? (
                            <span className="text-red-600 font-medium">
                              -₹{parseFloat(transaction.dr).toLocaleString('en-IN')}
                            </span>
                          ) : (
                            <span className="text-gray-400">-</span>
                          )}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-right font-medium">
                          ₹{parseFloat(transaction.balance).toLocaleString('en-IN')}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-8 text-gray-500">
                <svg className="w-12 h-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <p>No transactions found for this scheme and center combination.</p>
              </div>
            )}
          </>
        )}
      </div>

      {/* Footer */}
      <div className="p-4 border-t border-gray-200 bg-gray-50">
        <div className="flex justify-end">
          <button
            onClick={closeLedgerPopup}
            className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}
    
    </div>
  );
};

// Add a fadeIn animation in your CSS
// Add this either to your CSS file or to the <style> section in your HTML
/*
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
.animate-fadeIn {
  animation: fadeIn 0.3s ease-in-out;
}
*/

export default ListView;